import { Component, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@base/base.component';
import { DateHelper } from '@helpers/data-helper';
import { GetSalesReportQuery, GetSalesReportQueryResponse } from '@models/reports/reports';
import { ReportsService } from '@services/reports.service';
import { Subscription } from 'rxjs';
import { PERMITION_CONSORTIUM_SALES_PANEL_READ_DETAILS } from 'src/app/const/permitions';

@Component({
  selector: 'app-summary-sales',
  templateUrl: './summary-sales.component.html',
  styleUrl: './summary-sales.component.scss'
})
export class SummarySalesComponent extends BaseComponent implements OnDestroy {
  public form: FormGroup;
  private firstSearchDone: boolean = false;
  public sales: GetSalesReportQueryResponse[] = [];
  private _salesReportSubscription: Subscription;
  public startDate: Date;
  public endDate: Date;
  public isLoading: boolean = false;

  public constructor(private readonly _reportsService: ReportsService) {
    super();
  }

  public ngOnInit() {

    this._salesReportSubscription = this._reportsService.salesReportStramSubject.subscribe(result => {
      this.sales = result;
      this.isLoading = false;
    });

    this.startDate = DateHelper.yearsAgo(DateHelper.currentDate, 4);
    this.endDate = DateHelper.currentDate;

    this.filter();
  }

  public ngOnDestroy(): void {
    this._salesReportSubscription.unsubscribe();
  }

  public get hasAccessToAnyDealer() {
    return this.getAllAllowedDealers().length > 0;
  }

  public get hasPermissionToViewDetails() {
      return this.getPermissions()
                 .some(p => [PERMITION_CONSORTIUM_SALES_PANEL_READ_DETAILS].includes(p));
    }

  public filter(): void {
    try {
      if (!this.hasAccessToAnyDealer) {
        return;
      }

      let params: GetSalesReportQuery = {
        identifierCode: this.getAccessPoint().identifierCode,
        startDate: this.startDate,
        endDate: this.endDate
      };

      this.isLoading = true;
      this._reportsService.getSalesReportSummary(params, this.firstSearchDone);
    } catch(error) {
      this.openDialogError(error)
    } finally {
      this.firstSearchDone = true;
    }
  }

  public aggregateSales(sales: GetSalesReportQueryResponse[]): number {
    return sales.map(s => s.salesCount).reduce((agg, v) => agg + v);
  }

}
